import request from "../request";
import sysrequest from "../sysrequest";
// 案件管理的api

const api = {
  // 區處列表查詢
  division_info_list(data) {
    const obj = {
      url: "/bid/demo_v1/division_info/list/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },

  // /bid/demo_v1/division_info/update/
  division_info_update(data) {
    const obj = {
      url: "/bid/demo_v1/division_info/update/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },

  // /bid/demo_v1/division_info/delete/
  division_info_delete(data) {
    const obj = {
      url: "/bid/demo_v1/division_info/delete/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },

  // /bid/demo_v1/division_info/create/
  division_info_create(data) {
    const obj = {
      url: "/bid/demo_v1/division_info/create/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },

  // 分行中的聯絡人清單
  contact_list_search(data) {
    const obj = {
      url: "/bid/demo_v1/contact_list/search/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },
};

export default api;
